import React from "react";
import "./Team.css";
import teamConfig from "../../config/team.json"

const teamMembers = teamConfig.players;

const Team = () => {
  const TeamPhoto = "https://gladiator-website-amplify.s3.eu-west-2.amazonaws.com/pics/team-photo-new.jpeg"

  return (
    <section className="team-section">
      <div className="team-container">
        <h3 className="small-title">{teamConfig.title}</h3>
        <h1 className="main-title">{teamConfig.mainTitle}</h1>
        <p className="section-subtitle">{teamConfig.subTitle}</p>
        <div className="team-image-wrapper">
          <img
            src={TeamPhoto}
            alt="Our Team"
            className="team-image"
          />
        </div>
        <div className="team-grid">
          {teamMembers.map((member) => (
            <div key={member.id} className="team-member">
              <div className="circle">{member.jerseyNumber}</div>
              <h3 className="name">{member.name}</h3>
              <p className="title">{member.role}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Team;
